import { ReactComponent as AvalancheAvaxIcon } from '#/assets/icons/network/avalanche-avax-logo.svg';
import { ReactComponent as CardanoAdaIcon } from '#/assets/icons/network/cardano-ada-logo.svg';
import { ReactComponent as CosmosAtomIcon } from '#/assets/icons/network/cosmos-atom-logo.svg';
import { ReactComponent as EthereumEthIcon } from '#/assets/icons/network/ethereum-eth-logo.svg';
import { ReactComponent as KusamaKsmIcon } from '#/assets/icons/network/kusama-ksm-logo.svg';
import { ReactComponent as NearNearIcon } from '#/assets/icons/network/near-protocol-near-logo.svg';
import { ReactComponent as OasisNetworkRoseIcon } from '#/assets/icons/network/oasis-network-rose-logo.svg';
import { ReactComponent as OsmosisOsmoIcon } from '#/assets/icons/network/osmosis-osmo-logo.svg';
import { ReactComponent as PersistenceXprtIcon } from '#/assets/icons/network/persistence-xprt-logo.svg';
import { ReactComponent as PolkadotDotIcon } from '#/assets/icons/network/polkadot-new-dot-logo.svg';
import { ReactComponent as PolygonMaticIcon } from '#/assets/icons/network/polygon-matic-logo.svg';
import { ReactComponent as SolanaSolIcon } from '#/assets/icons/network/solana-sol-logo.svg';
import { ReactComponent as UmeeUmeeIcon } from '#/assets/icons/network/umee-umee-logo.svg';
import matchSwitch, { _ } from 'match-switch';
import { FC, SVGAttributes, SVGProps, useMemo } from 'react';
import { HiQuestionMarkCircle } from 'react-icons/hi';

interface Props extends SVGAttributes<SVGElement> {
  symbol?: string;
}

export function NetworkAvatar({ symbol, ...props }: Props) {
  const IconComponent = useMemo<FC<SVGProps<SVGSVGElement>> | null>(
    () =>
      matchSwitch(symbol, {
        ADA: CardanoAdaIcon,
        ATOM: CosmosAtomIcon,
        AVAX: AvalancheAvaxIcon,
        DOT: PolkadotDotIcon,
        ETH: EthereumEthIcon,
        KSM: KusamaKsmIcon,
        MATIC: PolygonMaticIcon,
        ROSE: OasisNetworkRoseIcon,
        SOL: SolanaSolIcon,
        XPRT: PersistenceXprtIcon,
        UMEE: UmeeUmeeIcon,
        OSMO: OsmosisOsmoIcon,
        NEAR: NearNearIcon,
        [_]: HiQuestionMarkCircle,
      }),
    [symbol]
  );
  return IconComponent ? <IconComponent {...props} /> : null;
}
